<template>
    <sa-page-layout>
        <template slot="toolbar">
            <!-- <b-button class="float-sm-right" variant="success btn-toolbar sa-margin-right" size="sm"
        @click="onAggiungiModificaAccettazione"><b-icon icon="plus"></b-icon>Nuova Accettazione</b-button>
      <b-button variant="purple  btn-toolbar float-sm-right sa-margin-right" size="sm"
        @click="onClickNuovaAccettazioneNRE()"> <b-icon size="large" icon="folder-plus"></b-icon>Nuova Accettazione
        NRE</b-button> -->
        </template>
        <template slot="table-filter">
            <b-form style="width: 100%" @submit.prevent="submit">
                <div class="sa-form-section sa-search-box">
                    <b-row style="margin-left: 0.5rem; margin-right: 0.5rem" class="sa-form-btn-filter">
                        <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                            <label class="sa-label-data">Presidio:</label>
                            <b-form-select id="inline-form-custom-select-pref" v-model="filtro.idPresidio"
                                class="mb-2 mr-sm-2 mb-sm-0" :value="null" value-field="idPresidio"
                                text-field="denominazionePresidio" :options="presidiOptions">
                                <template #first>
                                    <b-form-select-option :value="null">TUTTI</b-form-select-option>
                                </template>


                            </b-form-select>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
                            <label class="sa-label-data">Prestazione:</label>
                            <b-form-select v-model="filtro.prestazione" :options="agendaPrestazioniOptions"
                                text-field="descrizionePrestazione" value-field="codicePrestazione">
                                <template #first>
                                    <b-form-select-option :value="null">- TUTTE -</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>

                        <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
                            <label class="sa-label-data">Data dals:</label>
                            <date-picker v-model="filtro.dataRiferimentoDal" format="DD-MM-YYYY" value-type="timestamp"
                                placeholder="Seleziona data iniziale" type="date"> </date-picker>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
                            <label class="sa-label-data">Data al:</label>
                            <date-picker v-model="filtro.dataRiferimentoAl" format="DD-MM-YYYY" value-type="timestamp"
                                placeholder="Seleziona data finale" type="date"> </date-picker>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
                            <label class="sa-label-data">Codice NRE</label>
                            <b-form-input v-model="filtro.codiceBar2"></b-form-input>

                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
                            <label class="sa-label-data">Cognome:</label>
                            <b-form-input v-model="filtro.cognome"></b-form-input>

                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
                            <label class="sa-label-data">Nome:</label>
                            <b-form-input v-model="filtro.nome"></b-form-input>

                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
                            <label class="sa-label-data">Identificativo:</label>
                            <b-form-input v-model="filtro.cf"></b-form-input>
                        </b-col>
                    </b-row>
                    <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12"
                            class="sa-padding-right pt-3 pb-3 text-right">

                            <b-button v-on:click="onReset" variant="danger">{{
                                this.$i18n.t("patients.lblResetFilter")
                                }}</b-button>
                            <b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                        </b-col>
                    </b-row>

                </div>
            </b-form>
        </template>
        <template slot="table-body">
            <div style="height: 100%; box-sizing: border-box;">
                <AccettazioneSsnImpegnativaComponent :component="true" :isEdit="true"
                    :jsonData="{ accettazione: { accettazioneAnagrafica: {}, accettazionePresidio: {} } }"
                    :ricette="ricette" ref="cmpAccettazioneSsnImpegnativaComponent" @ricetteLoad="onRicetteLoad" />
            </div>
        </template>

    </sa-page-layout>

</template>

<script>
import DatePicker from "vue2-datepicker";
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
// import AccettazionePrestazioniListComponent from "../../appuntamenti/components/AccettazionePrestazioniListComponent.vue"
import PresidiPrestazioniMixins from "../../../strutture/presidiprestazioni/mixins/PresidiPrestazioniMixins.js";
import PresidiMixin from "../../../strutture/mixins/PresidiMixin.js";
import AccettazioneSsnImpegnativaComponent from "../../ssn/components/AccettazioneSsnImpegnativaComponent.vue";

export default {
    mixins: [PresidiPrestazioniMixins, PresidiMixin],
    // AccettazionePrestazioniListComponent

    components: { SaPageLayout, DatePicker, AccettazioneSsnImpegnativaComponent },
    watch: {
        'filtro.idPresidio': function (params) {

            if (params) {
                console.log(this.agendaPrestazioniOptions);

                let presidio = this.agendaPrestazioniOptions.find(e => e.idPresidio == params);
                if (presidio) {
                    this.loadPrestazioniPresidio(presidio.codice)
                }
            }
        }
    },
    data() {
        return {
            agendaPrestazioniOptions: [],
            filtro: {
                dataRiferimentoDal: null,
                dataRiferimentoAl: null,
                idPresidio: null,
                prestazione: null,
                cf: null,
                codiceBar2: null

            },
            ricette: [],
            presidio: {},
            title: "Riepilogo Impegnativa"
        };
    },
    mounted() {
        this.getPresidio();
        this.loadUtentePresidio();
        this.setDataRiferimento();

    },
    methods: {
        setDataRiferimento() {
            const oggi = new Date();
            oggi.setHours(23, 59, 59, 999);
            const fineOggiLong = oggi.getTime();
            const inizioSettimanaScorsa = new Date();
            inizioSettimanaScorsa.setDate(inizioSettimanaScorsa.getDate() - 7);
            inizioSettimanaScorsa.setHours(0, 0, 0, 0);
            const inizioSettimanaScorsaLong = inizioSettimanaScorsa.getTime();

            this.filtro.dataRiferimentoDal = inizioSettimanaScorsaLong;
            this.filtro.dataRiferimentoAl = fineOggiLong;
        },
        onRicetteLoad(ricette) {
            this.ricette = ricette;
        },
        submit() {


            this.$refs.cmpAccettazioneSsnImpegnativaComponent.loadRicette(this.filtro);
        },

        loadUtentePresidio() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            if (sessionStorage.getItem("user")) {
                let user = JSON.parse(sessionStorage.getItem("user"));
                me.loadPresidiUtente(user.id, this.loadUtentePresidioSuccess);
            }
        },
        loadUtentePresidioSuccess() {
            if (this.presidio) {
                this.filtro.idPresidio = this.presidio.idPresidio
                this.loadPrestazioniPresidio(this.presidio.codicePresidio)
            }
        },
        loadPrestazioniPresidio(codicePresidio) {
            this.agendaPrestazioniOptions = [];
            PresidiPrestazioniMixins.methods.loadPrestazioniPresidioByCodicePresidio(codicePresidio, this.callBackSuccessLoadPresidiPrestazioni);

        },
        getPresidio() {
            let tmpPresidio = window.localStorage.getItem("presidio");
            if (tmpPresidio) {
                this.presidio = JSON.parse(tmpPresidio);
            }
        },
        callBackSuccessLoadPresidiPrestazioni(response) {
            let prestazioni = response.data.data.list.map(item => ({
                idPresidio: item.id,
                codicePrestazione: item.codice,
                descrizionePrestazione: item.descrizione
            }));

            this.agendaPrestazioniOptions = prestazioni;
            this.submit();


        },
        onReset() {
            this.filtro = {
                dataRiferimentoDal: null,
                dataRiferimentoAl: null,
                prestazione: null,
                cf: null,
                codiceBar2: null
            }
            this.filtro.idPresidio = this.presidio.idPresidio
            this.setDataRiferimento();

        }
    }

}
</script>

<style lang="scss" scoped></style>